import ListAggregatedData from './ListAggregatedData'

export default ListAggregatedData
